import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import EmailIcon from '@segment/matcha/components/Icons/components/Brandbook/EmailIcon'
import UserIcon from '@segment/matcha/components/Icons/components/Brandbook/UserIcon'

import EventItemBase, * as EventItem from '@segment/matcha/recipes/EventItem'

import EventFlow from '@segment/matcha/recipes/EventFlow'

const events = [
  {
    label: `Emails Today`,
    sublabel: `3`,
    detail: `24s`,
    icon: <EmailIcon />,
  },
  {
    label: `Propensity to Buy 14 Days`,
    sublabel: `75%`,
    detail: `2m`,
    icon: <UserIcon />,
  },
]

const codeEvent = {
  code: `Push traits to build real-time audiences`,
}

export const PushTraits = () => {
  const theme = useTheme()
  return (
    <Wrapper>
      <EventFlow
        id="push-traits"
        gap="16px"
        gradient={
          <>
            <stop stopColor={theme.palette.twilio.green[50]} stopOpacity="0" />
            <stop offset="0.48183" stopColor={theme.palette.twilio.green[50]} stopOpacity="0.5" />
            <stop offset="1" stopColor={theme.palette.twilio.green[50]} stopOpacity="0" />
          </>
        }
        gradientDots={
          <>
            <stop stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
            <stop offset="0.489183" stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
            <stop offset="1" stopColor={theme.palette.neutrals.white[100]} stopOpacity="1" />
          </>
        }
      >
        {events.map((event) => (
          <EventItemBase key={event.label}>
            <EventItem.Icon>{event.icon}</EventItem.Icon>
            <EventItem.Body>
              <EventItem.Label tokens={{ color: theme.palette.brand.darkAcai[400] }}>{event.label}</EventItem.Label>
              <EventItem.Label>{event.sublabel}</EventItem.Label>
            </EventItem.Body>
            <EventItem.Detail>{event.detail}</EventItem.Detail>
          </EventItemBase>
        ))}

        <EventItemBase background={theme.palette.twilio.boysenberry[60]} size="small" textAlign="center">
          <EventItem.Body>
            <EventItem.Code tokens={{ color: theme.palette.neutrals.white[100] }}>{codeEvent.code}</EventItem.Code>
          </EventItem.Body>
        </EventItemBase>
      </EventFlow>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  min-height: 430px;
  padding: 0 14px;
`

export default PushTraits
